<ra-modal [title]="'document.edit.checklist.responsibles.title' | translate" (close)="close.emit()">
    @if (loading()) {
        <div class="container-loading">
            <ra-loading [message]="'document.edit.checklist.responsibles.loading' | translate"/>
        </div>
    }
    @else {
        <div class="modal-content">
            <!-- Description -->
            <p class="ra-label-s description-message">
                {{ 'document.edit.checklist.responsibles.hint' | translate }}
            </p>

            <!-- Explica o que significa ser da equipe do documento -->
            <div class="members-info">
                <ra-icon icon="info-circle" varColor="primary" [size]="16" />
                <p class="ra-label-xs">{{ 'document.edit.checklist.responsibles.info' | translate }}</p>
            </div>

            @if (members().length === 0) {
                <div class="container-empty">
                    <ra-empty
                        [marginTop]="24"
                        [message]="'document.edit.checklist.responsibles.emptyAvailable' | translate"/>
                </div>
            }
            @else {
                <!-- Lista da equipe: switch salva na hora -->
                <div class="container-members-list">
                    @for (member of members(); track member._id) {
                        <div class="member-item">
                            <div class="member-left">
                                <div class="member-info">
                                    <ra-user-avatar [user]="member" [avatarSize]="28" />

                                    <!-- Name and email -->
                                    <div class="member-name-email">
                                        <p class="ra-label-s">
                                            {{ member.name }}
                                            @if (member._id === currentUserId) {
                                                <span class="you-badge">{{ 'document.edit.checklist.responsibles.you' | translate }}</span>
                                            }
                                        </p>
                                        <p class="ra-label-xs content-secondary">{{ member.email }}</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Switch à direita; salva na hora (travado durante a requisição) -->
                            <ra-switch
                                [formControl]="getMemberControl(member._id)"
                                [disabled]="savingIds().has(member._id)"
                            />
                        </div>
                    }
                </div>
            }
        </div>
    }
</ra-modal>
